export const myaccountActions = (type, payload) => {
  return {
    type: type,
    payload,
  };
};
